<template>
    <div class="footer-container">
        <span>Copyright © <span style="cursor: pointer;" @click.prevent="gobandwel()">www.26cjn.com</span>, All Rights Reserved.</span>
		<span style="cursor: pointer;" @click.prevent="golink()">粤ICP备19104987号</span>
    </div>
</template>

<script>
export default {
    name: "",
    data() {
        return {};
    },
    components: {},
	methods:{
		gobandwel(){
			window.location.href = 'http://26cjn.com/'
		},
		golink(){
			window.location.href = 'https://beian.miit.gov.cn/#/Integrated/index'
		}
	}
};
</script>

<style lang="less" scoped>
.footer-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    line-height: 48px;
    text-align: center;
    font-size: 12px;
    color: #C0C4CC;
}
.link{
	color: #C0C4CC;
}
</style>
